'use client';
import React, { useEffect } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';
import Image404 from 'public/images/shy-lens.png';
import Image from 'frontastic/lib/image';
import { notFound, useRouter } from 'next/navigation';

const NotFound = () => {
  const { formatMessage } = useFormat({ name: 'common' });

  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push('/');
    }, 3000); // Redirect after 3 seconds

    return () => clearTimeout(timer); // Clean up the timer on unmount
  }, [router]);

  return (
    <div className="flex h-[80vh] flex-col items-center justify-start lg:h-[60vh] lg:justify-center">
      <Link link="/">
        <img
          src="https://res.cloudinary.com/dlwdq84ig/image/upload/w_1920,q_auto,c_scale/hmxukn29edc4npqhcint"
          alt="logo"
          className="mt-10 h-32 w-130 md:h-40 md:w-159 lg:h-67 lg:w-270"
        />
      </Link>

      <div className="mt-10 flex flex-col items-center justify-center gap-8 px-4 text-center lg:mt-20 lg:flex-row-reverse lg:gap-20 lg:text-left">
        <div className="h-[300px] w-[300px] lg:h-[350px] lg:w-[350px]">
          <Image src={Image404} alt={formatMessage({ id: 'page.notFound', defaultMessage: 'Page not found' })} />
        </div>

        <div>
          <h1 className="text-32">{formatMessage({ id: 'page.notFound', defaultMessage: 'Page not found' })}</h1>
          <p className="mt-6 text-16">
            {formatMessage({
              id: 'page.notFound.desc',
              defaultMessage:
                "The page you were looking for couldn't be found. It may have been deleted, renamed, or doesn't exist.",
            })}
          </p>
          <Link link="/">
            <Button variant="primary" className="mt-28 px-48 py-12 text-16 font-medium">
              {formatMessage({ id: 'page.notFound.cta', defaultMessage: 'Go back home' })}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
